import vtkGeometryRepresentationProxy from './GeometryRepresentationProxy';
import vtkGlyphRepresentationProxy from './GlyphRepresentationProxy';
import vtkMoleculeRepresentationProxy from './MoleculeRepresentationProxy';
import vtkSliceRepresentationProxy from './SliceRepresentationProxy';
import vtkVolumeRepresentationProxy from './VolumeRepresentationProxy';

export default {
  vtkGeometryRepresentationProxy,
  vtkGlyphRepresentationProxy,
  vtkMoleculeRepresentationProxy,
  vtkSliceRepresentationProxy,
  vtkVolumeRepresentationProxy,
};
